import { render, staticRenderFns } from "./v-flow-step.vue?vue&type=template&id=2a1249c3&scoped=true&"
import script from "./v-flow-step.vue?vue&type=script&lang=js&"
export * from "./v-flow-step.vue?vue&type=script&lang=js&"
import style0 from "./v-flow-step.vue?vue&type=style&index=0&id=2a1249c3&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a1249c3",
  null
  
)

export default component.exports